<template>
  <div class="container pay-result-container">
    <div class="pay-result">
      <template v-if="!paySuccess">
        <div class="status-title error">出票异常！</div>
        <div class="status-desc">
          尊敬的旅客，您好！请您在 <router-link class="seg-href" :to="orderHref">我的订单</router-link>中核实是否出票成功。若订单存在异常，请致电{{ hotline }}！
        </div>
      </template>
      <template v-else>
        <div class="status-title">恭喜你，购票成功！</div>
        <div class="status-timeout">将在<span class="_time">{{ timeout }}s</span> 后自动跳转出票订单：<router-link :to="orderHref">{{ orderNo }}</router-link> </div>
        <div class="marketing-text" v-if="marketingText">{{ marketingText }}</div>
      </template>
    </div>
    <div class="change-record">
      <div class="record-title">您的购票记录</div>
      <div class="pass-info">
        <template v-for="(pass, passIndex) in detail.travelers">
          <div class="pass-item" :key="passIndex">
            <div class="order-primary-header">
              <l8-icon class="l8-icon" type="icon-lvke"/>
              <span class="header-label">旅客{{ passIndex + 1 }}</span>
              <span class="header-msg">
              <span>{{ pass.fullName }}</span>
              <span>{{ getCertificateTypeCn(pass.certificateType) }}：{{ pass.certificateNo }}</span>
          </span>
            </div>
            <div class="change-seg-table-wrap">
              <table class="order-default-table change-seg-table">
                <thead>
                <tr>
                  <td>行程</td>
                  <td>起飞时间</td>
                  <td>到达时间</td>
                  <td>航空公司</td>
                  <td>航班号</td>
                  <td>机型</td>
                </tr>
                </thead>
                <tbody>
                <template v-for="(newSeg, newSegIdx) in pass.flightSegments">
                  <tr :key="'newSeg' + newSegIdx">
                    <td>{{ newSeg.departureAirPortName }} - {{ newSeg.arrivalAirPortName}}</td>
                    <td>{{ newSeg.departureTime }}</td>
                    <td>{{ newSeg.arrivalTime }}</td>
                    <td>{{ newSeg.airlineName }}</td>
                    <td>{{ newSeg.flightNo || '--' }}</td>
                    <td>{{ newSeg.aircraftCode || '--'  }}</td>
                  </tr>
                </template>
                </tbody>
              </table>
            </div>
          </div>
          <template v-if="pass.infantTravelers && pass.infantTravelers.length">
            <div class="pass-item"
                 v-for="(inf, infIndex) in pass.infantTravelers"
                 :key="passIndex + '_' + infIndex"
            >
              <div class="order-primary-header">
                <l8-icon class="l8-icon" type="icon-lvke"/>
                <span class="header-label">旅客{{ passIndex + 1 }} <small>携带婴儿</small></span>
                <span class="header-msg">
              <span>{{ inf.fullName }}</span>
              <span>{{ getCertificateTypeCn(inf.certificateType) }}：{{ inf.certificateNo }}</span>
          </span>
              </div>
              <div class="change-seg-table-wrap">
                <table class="order-default-table change-seg-table">
                  <thead>
                  <tr>
                    <td>行程</td>
                    <td>起飞时间</td>
                    <td>到达时间</td>
                    <td>航空公司</td>
                    <td>航班号</td>
                    <td>机型</td>
                  </tr>
                  </thead>
                  <tbody>
                  <template v-for="(newSeg, newSegIdx) in inf.flightSegments">
                    <tr :key="'newSeg' + newSegIdx">
                      <td>{{ newSeg.departureAirPortName }} - {{ newSeg.arrivalAirPortName}}</td>
                      <td>{{ newSeg.departureTime }}</td>
                      <td>{{ newSeg.arrivalTime }}</td>
                      <td>{{ newSeg.airlineName }}</td>
                      <td>{{ newSeg.flightNo || '--' }}</td>
                      <td>{{ newSeg.aircraftCode || '--'  }}</td>
                    </tr>
                  </template>
                  </tbody>
                </table>
              </div>
            </div>
          </template>
        </template>
      </div>
    </div>
    <div class="exs-adv" v-if="servicesList?.length > 0">
      <div class="adv-title">现在，您还可以预订以下增值服务</div>
      <div class="exs-adv-list">
        <div class="adv-item" v-for="(svc, svcIndex) in servicesList" :key="svcIndex">
          <a :href="svc.url || '#'" :target="svc.target">
            <img class="adv-img" :src="svc.image" alt="">
          </a>
          <p class="adv-desc">{{ svc.title }}</p>
        </div>
      </div>
    </div>
    <div class="change-notice" v-if="payResultTips">
      <div class="notice-h">温馨提示</div>
      <div v-html="payResultTips"></div>
    </div>
  </div>
</template>

<script>
import { queryDetailV2, orderDataGA } from '@/apis/order'
import { syncTicketNo } from '@/apis/pay'
import { get, some } from 'lodash'

import queryString from 'query-string'
import Storage from '@/assets/js/storage'
import './index'
import mixinPayCallBack from '@/components/mixinPayCallback'

import '@/components/l8-icon'
import '@/assets/css/l8-order-common.less'
import getAppInfo from '@/utils/from'

const mainSettings = window.__MICRO_ROOT__ ?? {}
let _mixinPayCallBack = mixinPayCallBack

const CertificateTypeCn = {
  'NI': '身份证',
  'ID16': '户口簿',
  'PP': '有效护照',
  'JG': '军官证',
  'NID': '外国人永久居留身份证',
  'HM': '港澳台居民居住证',
  'ID': '其他'
}

export default {
  mixins: [_mixinPayCallBack],
  data () {
    return {
      detail: {},
      orderId: '',
      orderNo: '',
      paySuccess: null,
      timeout: 10,
      servicesList: [],
      hotline: getAppInfo()?.hotline,
      payResultTips: '',
      ifInternational: false,
      seller: mainSettings.airline,
      sellerChannel: 'C' + mainSettings.airline.toLocaleUpperCase(),
      marketingText: ''
    }
  },
  computed: {
    orderHref () {
      const { ifInternational, orderId, orderNo, seller, sellerChannel } = this
      return !ifInternational ? `/order/v2/detail?orderId=${orderId}&seller=${seller}&sellerChannel=${sellerChannel}` : `/order/v2/detail?orderNo=${orderNo}&ifInternational=${ifInternational}&seller=${seller}&sellerChannel=${sellerChannel}`
    }
  },
  created () {
    const query = queryString.parse(location.search)
    if (this.payCallbackParams !== null) {
      let extraParam = this.payCallbackParams
      this.orderId = extraParam.orderId
      this.orderNo = extraParam.orderNo
      this.ifInternational = extraParam.ifInternational ? JSON.parse(extraParam.ifInternational) : false
      this.paySuccess = extraParam.paySuccess ? extraParam.paySuccess === 'true' : true

      if (extraParam.seller) {
        this.seller = extraParam.seller
      }

      if (extraParam.sellerChannel) {
        this.sellerChannel = extraParam.sellerChannel
      }
    } else {
      this.orderId = query.orderId
      this.orderNo = query.orderNo
      this.ifInternational = query.ifInternational === 'true'
      this.paySuccess = query.paySuccess ? query.paySuccess === 'true' : true
    }

    this.fetchOrderDetail()

    let syncFlag = Storage.getItem('syncFlag')

    // 防止刷新重复同步票号
    if (!syncFlag || syncFlag !== this.orderId) {
      this.fetchSyncTicketNo()
    }

    // this.fetchGAInfo()
    // this.updateServices()
    this.getCmsData()
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  methods: {
    async getCmsData () {
      try {
        const cmsData = (await mainSettings.cms?.getPageData()) || {}
        this.payResultTips = get(cmsData, 'pay-result-tips.content')
      } catch (err) {}
    },
    fetchOrderDetail: function () {
      const { orderId, orderNo, ifInternational, seller, sellerChannel } = this
      let params = {
        airline: mainSettings.airline,
        ifInternational,
        seller,
        sellerChannel
      }
      if (!ifInternational) {
        params.orderId = orderId
      } else {
        params.orderNo = orderNo
      }
      queryDetailV2(params).then((res) => {
        this.updateOrderDetail(res.offers[0].detail)
      }).catch((err) => {
        this.$message.error(err.message || '订单查询失败，请稍后再试')
      })
    },
    updateOrderDetail (detail) {
      this.showMarketingText(detail)
      this.detail = detail
      this.orderNo = detail.orderNo

      this.$nextTick(() => {
        this.timer = setInterval(() => {
          if (this.timeout - 1 >= 0) {
            this.timeout = this.timeout - 1
          } else {
            clearInterval(this.timer)
            const { ifInternational, orderId, orderNo, seller, sellerChannel } = this
            const query = !ifInternational ? { orderId, seller, sellerChannel } : { orderNo, ifInternational, seller, sellerChannel }
            this.$router.push({ path: `/order/v2/detail`, query })
          }
        }, 1000)
      })
    },
    showMarketingText (detail) {
      const { value: userInfo } = Storage.getItem('USER_CENTER_INFO') || {}
      const { authStatus, fullName, userCerts } = userInfo
      let selfCertFlags = []
      if (userCerts?.length) {
        selfCertFlags = userCerts.map(cert => {
          return `${fullName}${cert.certNo?.slice(-4)}`
        })
      }
      const isAuth = authStatus === 4
      const hasSelf = some(detail.travelers, (t) => {
        const travelerFlag = `${t.fullName}${t.certificateNo?.slice(-4)}`
        return selfCertFlags.includes(travelerFlag)
      })
      const hasOther = detail.travelers.length > 1 || !hasSelf
      const hasChild = some(detail.travelers, (t) => t.type === 'CHILD')

      this.marketingText = '乘机人于实际乘机之日所属自然周内登录“海南航空”APP完成实名认证，可获得“飞飞乐”现金抽奖参与资格，最高奖项48888元。'
      if (isAuth) {
        if (hasChild) {
          this.marketingText = '恭喜您获得“飞飞乐”现金抽奖活动加倍抽奖机会！12周岁以下儿童实际乘机后，乘机人对应抽奖次数*2！每周二20:00，登录“海南航空”APP，进入“飞飞乐”活动专区，观看抽奖直播。'
        } else if (hasSelf) {
          this.marketingText = '实际乘机后即可参与“飞飞乐”现金抽奖参与资格，最高奖项48888元。本次乘机抽奖机会加倍，预祝您抽得大奖！每周二20:00，登录“海南航空”APP，进入“飞飞乐”活动专区，观看抽奖直播。'
        } else if (hasOther) {
          this.marketingText = '乘机人实际乘机后可参与“飞飞乐”现金抽奖，最高奖项48888元。每周二20:00，海南航空APP，“飞飞乐”活动专区。实名认证用户可享5重购票福利。'
        }
      }
    },
    fetchSyncTicketNo () {
      let params = {
        airline: mainSettings.airline,
        orderId: this.orderId
      }

      syncTicketNo(params).then((res) => {
        console.log('票号同步成功')
        try {
          Storage.setItem('syncFlag', this.orderId, 24 * 3600000)
        } catch (e) {
          this.$message.error('您的浏览器开启了无痕浏览模式，部分功能将无法使用，请关闭无痕浏览模式。')
        }
      }).catch((err) => {
        this.$message.error(err.message || '票号同步失败')
      })
    },
    fetchGAInfo () {
      let params = {
        orderId: this.orderId
      }

      orderDataGA(params).then((res) => {
        if (res.status === '1') { // 正常机票下单
          this.payGaTrace(res)
        }
      }).catch((err) => {
        console.log(err.message || 'GA信息获取失败')
      })
    },
    payGaTrace (data) {
      window.ga('TrueMetrics.set', 'currencyCode', data.currencyCode)
      for (let passengerTypeKey in data.passengerTypeMap) {
        let passengerTypeName = ''
        if (passengerTypeKey === 'ADULT') {
          passengerTypeName = '成人'
        } else if (passengerTypeKey === 'CHILD') {
          passengerTypeName = '儿童'
        } else {
          passengerTypeName = '婴儿'
        }
        let quantity = data.passengerTypeMap[passengerTypeKey]
        let i = 1
        for (let flightKey in data.flightMap) {
          let flightCode = '去程'
          if (i > 1) {
            flightCode = '回程'
          }
          i++
          let id = data.flightMap[flightKey]
          let category = passengerTypeName + '|' + data.cabinMap[flightKey] + '|' + flightCode
          let name = id.split('#')[1]

          window.ga('TrueMetrics.ec:addProduct', {
            'id': id,
            'category': category,
            'name': name,
            'quantity': quantity
          })
        }
      }

      window.ga('TrueMetrics.ec:setAction', 'purchase', {
        'id': data.pnrNos,
        'tax': data.tax,
        'affiliation': data.affiliation,
        'coupon': data.couponCode,
        'revenue': data.revenue
      })

      window.ga('TrueMetrics.send', 'event', 'Purchase', 'Success', data.pnrNos, {
        nonInteraction: true,
        dimension4: data.netFare,
        dimension5: data.luggageFee,
        dimension6: data.viphalfee,
        dimension7: data.airportTax,
        dimension8: data.fuelTax,
        dimension9: data.mealFee
      })
    },
    updateServices () {
      this.servicesList = window.servicesList.production
    },
    getCertificateTypeCn (status) {
      return CertificateTypeCn[status] || '--'
    }
  }
}
</script>

<style lang="less">
.pay-result {
  text-align: center;
  margin: 54px 0 18px;
}

.status-title {
  font-size: 24px;
  font-weight: bold;

  &.error {
    color: @primary-color;
  }
}

.status-timeout {
  padding-top: 20px;
  font-size: 14px;

  ._time {
    color: @primary-color;
  }
}

.status-desc {
  font-size: 12px;
  margin-top: 12px;
}

.change-record {
}

.record-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
}

.record-subtitle {
  font-size: 12px;
  color: @primary-color;
  margin: 14px 0;
}

.pass-info {
}

.pass-item {
  + .pass-item {
    margin-top: 30px;
  }
}

.change-seg-table {
  &.order-default-table tbody tr td {
    padding: 14px 10px;
  }

  &.order-default-table tbody tr td:first-child {
    padding-left: 30px;
  }

  .seg-line {
    position: relative;
  }

  .seg-tip {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    color: #fff;
    text-decoration: none;

    span {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 2;
      font-style: normal;
      margin: 3px;
      font-size: 10px;
    }

    &:before {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1;
      content: "";
      display: block;
      width: 0;
      height: 0;
      border-top: 30px solid red;
      border-right: 30px solid transparent;
    }

    &.seg-old {
      &:before {
        border-top: 30px solid #808080;
      }
    }
  }
}

.change-notice {
  margin-top: 20px;
}

.exs-adv {
  margin-top: 50px;
}

.adv-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 14px;
}

.exs-adv-list {
  width: 100%;
  text-align: center;
  display: table;

  .adv-item {
    cursor: pointer;
    display: table-cell;
  }
}

.adv-img {
  display: block;
  height: 230px;
  width: 310px;
}

.adv-desc {
  font-size: 14px;
  text-align: center;
  margin: 10px 0;
}

@media only screen and (max-width: 768px) {
  .change-seg-table-wrap {
    overflow-x: scroll;
  }

  .exs-adv-list {
    display: block;

    .adv-item {
      display: block;
    }
  }
}
</style>
